import React, { useState, useEffect } from 'react';

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Use unique IDs and correct paths – make sure these images exist in your public folder
  const slides = [
     { id: 3, image: '/banner3.png' },
    { id: 1, image: '/banner1.jpeg' },
    { id: 2, image: '/banner2.jpeg' },
    { id: 3, image: '/banner3.png' }
  ];

  // Autoplay every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [slides.length]);

  // Fallback if image fails to load – uses a placeholder with same background color
  const handleImageError = (e) => {
    e.target.src = 'https://placehold.co/1200x650/1e1e1e/amber?text=Kanak+Jewellers';
    e.target.alt = 'Banner placeholder';
  };

  return (
    <section className="relative w-full bg-stone-900">
      {/* Slides container – height scales with viewport */}
      <div className="relative w-full h-[200px] sm:h-[300px] md:h-[450px] lg:h-[550px] xl:h-[650px] overflow-hidden">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 w-full h-auto transition-opacity duration-1000 ease-in-out ${
              index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'
            }`}
          >
            <img
              src={slide.image}
              alt={`Banner ${slide.id}`}
              className="w-full h-full object-cover"
              onError={handleImageError}
            />
          </div>
        ))}
      </div>

      {/* Navigation dots */}
      <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 flex gap-2 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`rounded-full transition-all duration-300 ${
              index === currentSlide
                ? 'w-6 h-2.5 bg-amber-400'
                : 'w-2.5 h-2.5 bg-amber-200/70 hover:bg-amber-300'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Banner;
